"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { ConfirmThoughtsRequest } from "@/generated/fastapi";
import { useAuth } from "@/state/globalStore";
import { confirmThoughts } from "../api/confirmThoughts";
import { thoughtKeys } from "../queries/keys";

export default function useConfirmThoughtsMutation() {
  const queryClient = useQueryClient();
  const { accessToken } = useAuth();

  return useMutation({
    mutationFn: (request: ConfirmThoughtsRequest) =>
      confirmThoughts(accessToken, request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: thoughtKeys.all });
    },
  });
}
